import { render, staticRenderFns } from "./InactiveIcon.vue?vue&type=template&id=05dac738&"
import script from "./InactiveIcon.vue?vue&type=script&lang=js&"
export * from "./InactiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports